module.exports = __webpack_public_path__ + "img/toll-free-icon.b5a1a25b.svg";